<template>
  <div class="homepage-offers">
    <h2 v-html="vueHomepageOffersTexts.textStrings.headline"></h2>
    <slider v-if="products.length > 0" :amount-of-slides="products.length">
      <template v-for="(product, index) in products">
        <single-product-complement :key="`product-${product.matchcode}-${index}`"
                                   :product-info="product"
                                   :t="vueHomepageOffersTexts.textStrings"></single-product-complement>
      </template>
    </slider>
    <span v-html="vueHomepageOffersTexts.textStrings.noOffersAvailable" v-if="products.length === 0 && !loading"></span>
    <div class="cp-round cp-spinner" v-if="products.length === 0 && loading"></div>
  </div>
</template>

<script>
  import SingleProductComplement from "../layout/SingleProductComplement";
  import Slider from "../layout/Slider";
  import FetchHelper from "../../helpers/FetchHelper";
  import config from "../../../config";
  import CookieHelper from "./../../helpers/CookieHelper";

  export default {
    components: { SingleProductComplement, Slider },
    data: function () {
      return {
        loading: true,
        products: [],
        vueHomepageOffersTexts: window.vueHomepageOffersTexts,
        currency: false,
      };
    },
    methods: {
      fetchProductOffers: async function() {
        this.currency = await CookieHelper.getCurrency();
        let currencyQuery = '?c=' + this.currency;
        const fetchConfig = {
          path: `${config.api.paths.products.basepath}${config.api.paths.products.paths.reduced}${currencyQuery}`,
        };

        const fetchResult = await FetchHelper.get(fetchConfig);

        if(fetchResult.success) {
          this.products = [];
          fetchResult.data.forEach((product) => {
            if (false === product.partnerApplicationProduct) {
              this.products.push(product);
            }
          });
        } else {
          console.error(fetchResult);
        }
        this.loading = false;
      },
      setUp: async function() {
        await this.fetchProductOffers();
      },
    },
    mounted: function() {
      this.setUp();
    }
  }
</script>

<style lang="less" scoped>
  .homepage-offers {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 70px;
    width: 100%;
  }

  .rin-slider {
    height: 225px;
    padding-bottom: 115px;
    width: 100%;
  }
</style>
